import { phrases } from 'constants/phrases';
import * as yup from 'yup';

export const schema = yup.object({
  username: yup.string().required(phrases.usernameEmailEmpty),
  password: yup.string().required(phrases.passwordEmpty),
});
